import React, { useState, useEffect, useMemo } from "react";
import { SelectOption } from "../../input/SearchInput/types";
import { HgCountry } from "../../../types/taxonomy";
import { SearchInput } from "../../input/SearchInput/SearchInput";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";
import { LOCATION_MESSAGES } from "./constants";

interface CountryInputProps {
  selectedItems: string[];
  onCountrySelect: (countryAlpha2s: string[]) => void;
  isMultiple?: boolean;
  placeholderText?: string;
  disabled?: boolean;
}

const convertToCountryOptions = (countries: HgCountry[]): SelectOption[] => {
  return countries.map((country) => ({
    label: country.name || "",
    value: country.alpha2 || "",
  }));
};

export const CountryInput: React.FC<CountryInputProps> = ({
  selectedItems = [],
  onCountrySelect,
  isMultiple = true,
  placeholderText = LOCATION_MESSAGES.COUNTRY.PLACEHOLDER,
  disabled = false,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<SelectOption[]>([]);
  const { countries } = useTaxonomyContext();

  const allOptions = useMemo(
    () => convertToCountryOptions(countries as HgCountry[]),
    [countries]
  );

  useEffect(() => {
    if (allOptions.length > 0) {
      const initialSelectedOptions = allOptions.filter((option) =>
        selectedItems.includes(option.value)
      );
      setSelectedOptions(initialSelectedOptions);
    }
  }, [selectedItems, allOptions]);

  const handleOptionsSelect = (options: SelectOption[]) => {
    // Prevent clearing when not multiple
    if (!isMultiple && options.length === 0) {
      return;
    }
    setSelectedOptions(options);
    onCountrySelect(options.map((option) => option.value));
  };

  return (
    <SearchInput
      id="countries"
      options={allOptions}
      selectedOptions={selectedOptions}
      onOptionsSelect={handleOptionsSelect}
      placeholderText={placeholderText}
      noResultsMessage={LOCATION_MESSAGES.COUNTRY.NO_RESULTS}
      minFilterLength={1}
      isMultiple={isMultiple}
      disabled={disabled}
    />
  );
};
